<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" class="yx-flex-h-between" style="margin-top: 15px;">


                <div class="yx-flex-h-start">
                    <div>创建日期： <el-date-picker v-model="searchVal.transDateScope" value-format="yyyy-MM-dd" style="margin-right: 15px;width:250px" type="daterange" size="mini" unlink-panels start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" /></div>

                </div>


                <div class="yx-flex-h-start" >
                    <el-dropdown trigger="click" @command="changeMchStatus">
                        <el-button type="danger" icon="el-icon-setting" @click="" :disabled="disableBtn">
                            商户关停 <i class="el-icon-arrow-down el-icon--right" />
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item,index) in mchStatuses" :key=index :command="item.id">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

                <div>
                    <el-switch v-model="showActiveOnly" @change="changeQueryStatus" active-color="#13ce66" active-text="显示" inactive-text="隐藏" :width="switchLen" :active-value="switchActive" :inactive-value="switchInactive" />
                    <span style="color: rosybrown"> 已关停商户</span>
                </div>
            </div>





            <div class="yx-flex-h-start" style="margin-top: 15px;">
                <!--
                <el-button type="danger" icon="el-icon-plus" @click="viewAdd">商户进件</el-button>
                <el-dropdown trigger="click" @command="changeMchStatus">
                    <el-button type="danger" icon="el-icon-setting" @click="" :disabled="disableBtn">
                        更新状态 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                    </el-dropdown-menu>
                </el-dropdown>
                -->

            </div>

        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table :cell-style="columnbackgroundStyle"
                    :data="mchs"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="expand" label="">
                    <template slot-scope="props">
                        <div style="padding: 30px 0 30px 50px; width: 1000px;">
                            <el-descriptions class="margin-top" title="" :column="3" size="mini" border>
                                <template slot="extra">
                                </template>
                                <el-descriptions-item label="商户ID">{{ props.row.id }}</el-descriptions-item>
                                <el-descriptions-item label="服务商ID">{{ props.row.agentId }}</el-descriptions-item>
                                <el-descriptions-item label="业务员ID">{{ props.row.salesmanId }}</el-descriptions-item>
                                <template v-for="(item, index) in props.row.mchExtraChannelInfoWithBLOBsList">
                                    <el-descriptions-item >
                                        <template slot="label">{{item.payChannelCode}}更新时间</template>
                                        {{ item.updateTime }}
                                    </el-descriptions-item>
                                    <el-descriptions-item >
                                        <template slot="label">{{item.payChannelCode}}银联商户号</template>
                                        {{ item.channelCupMchNo }}
                                    </el-descriptions-item>
                                    <el-descriptions-item >
                                        <template slot="label">{{item.payChannelCode}}通道商户号</template>
                                        {{ item.channelMchNo }}
                                    </el-descriptions-item>
                                </template>


                                <el-descriptions-item v-for="(item, index) in props.row.devInfoList">
                                    <template slot="label">终端{{index+1}}SN</template>
                                    {{ item.terSn }}
                                </el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column prop="mchNo" label="商户号" width="100"></el-table-column>
                <el-table-column prop="mchName" label="商户名称" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shortName" label="简称" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" width="50" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status===1">正常</span>
                        <span v-else style="color: red;">关停</span>
                    </template>
                </el-table-column>
                <el-table-column label="终端数" width="60" align="center">
                    <template slot-scope="scope">
                        {{scope.row.devInfoList?scope.row.devInfoList.length:'-'}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="mchExtraChannelInfoWithBLOBsList"
                        label="进件状态"
                        width="280" >
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.mchExtraChannelInfoWithBLOBsList" class="yx-flex-h-start">
                            <el-tag type="info">
                                {{_enums.ProductChannelConvertEnum.getNameById(item.payChannelCode)}}
                                <i class="header-icon el-icon-loading" v-if="mchChannelWaitingStatusArr.indexOf(item.status)>-1" />
                                <i class="header-icon el-icon-warning-outline" v-if="mchChannelFailedStatusArr.indexOf(item.status)>-1" />
                                {{_enums.ChannelMchStatusEnum.getNameById(item.status)}}
                                <el-tooltip effect="light" v-if="mchChannelFailedStatusArr.indexOf(item.status)>-1" :disabled="item.channelRetMsg===null" placement="top">
                                    <div style="max-width: 200px" slot="content">
                                        <i class="header-icon el-icon-warning"></i>
                                        返回码：{{item.channelRetCode}}
                                        <br>
                                        {{item.channelRetMsg}}
                                    </div>
                                    <i class="header-icon el-icon-error" style="color: red">原因</i>
                                </el-tooltip>
                            </el-tag>
                            <el-tag v-if="_p_env.VUE_APP_MCH_SIGN_MSG_RESEND==='1' && mchChannelWaitingStatusArr.indexOf(item.status)===2" type="success" effect="dark" class="cls-tag2btn" @click="viewSignMsg(scope.row, item)" style="margin-left: 5px; ">
                                <i class="header-icon el-icon-message" /> 重发短信</el-tag>
                            <el-tag v-else-if="mchChannelFailedStatusArr.indexOf(item.status)>-1" type="warning" effect="dark" class="cls-tag2btn" @click="viewEdit(scope.row)" style="margin-left: 5px; ">
                                <i class="header-icon el-icon-edit" />修改</el-tag>
                        </div>
                    </template>
                </el-table-column>

                <!--
                <el-table-column prop="mchExtraChannelInfoWithBLOBsList" label="通道商户号" width="190" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.mchExtraChannelInfoWithBLOBsList" class="yx-flex-h-between">
                            <el-tag type="warning">{{item.payChannelCode}}</el-tag>{{item.channelMchNo}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="mchExtraChannelInfoWithBLOBsList" label="银联商户号" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.mchExtraChannelInfoWithBLOBsList" class="yx-flex-h-between">
                            <el-tag type="success">{{item.payChannelCode}}</el-tag>{{item.channelCupMchNo}}
                        </div>
                    </template>
                </el-table-column>
                -->

                <el-table-column prop="salesmanName" label="客户经理" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="agentName" label="服务商" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createWay" label="创建方式" width="80">
                    <template slot-scope="scope">{{_enums.MchCreateWayEnum.getNameById(scope.row.createWay)}}</template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="yx-flex-h-center" >
                            <el-button type="text"  size="mini" @click="viewDetail(scope.row)">详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev, pager, next, jumper, ->, total, slot"
                    :total="total">
            </el-pagination>
        </div>

        <el-drawer
                :title=mchInfo.mchName
                :with-header="false"
                :visible.sync="drawer"
                :show-close=false
                size = "65%"
                direction="rtl">
            <div style="padding: 0 10px 30px 10px">
                <el-table :data="[mchInfo]" style="padding-left: 0px">
                    <el-table-column prop="mchNo" label="商户编号" />
                    <el-table-column prop="shortName" label="商户简称" />
                    <el-table-column prop="status" label="状态" >
                        <template slot-scope="scope">
                            {{_enums.MchStatusEnum.getNameById(scope.row.status)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" />
                </el-table>
            </div>
            <MchDetailDiv :key="mchInfo.id" v-bind:inMchInfo="mchInfo"></MchDetailDiv>
        </el-drawer>

        <MchBaseDlg v-if="$root.g_data_user_product_rate && $root.g_data_business_category" :key="keyCompMchDlg" v-bind:inOptType="dlgModel" v-bind:inMchInfo="mchInfo"  v-bind:outDlgClosed.sync="dlgClosed" />

        <el-dialog
                :title="radio1Text"
                class="dlg-normal"
                style="width: 400px; margin: 200px auto auto;"
                :visible.sync="prdChoseDlgVisible"
                :close-on-click-modal="false">
            <div class="yx-flex-h-center">
                <el-radio-group v-model="radio1" @change="radio1Changed">
                    <el-radio-button
                            :label="_enums.ProductChannelConvertEnum.getNameById(item.payChannelCode)" v-for="(item, index) in radioData"></el-radio-button>
                </el-radio-group>
            </div>
        </el-dialog>


    </div>

</template>

<script>

    import {
    } from "../../utils/cons";
    import {deepClone, findIdxByKeyValue} from '../../utils/datatool'
    import MchDetailDiv from "../../components/mch/MchDetailDiv";
    import MchBaseDlg from "../../components/mch/MchBaseDlg";

    export default {
        name: "MchInfo",
        components: { MchDetailDiv,  MchBaseDlg},
        data() {
            return {
                mchChannelFailedStatusArr: [
                    this._enums.ChannelMchStatusEnum.未知状态.id,
                    this._enums.ChannelMchStatusEnum.进件失败.id,
                    this._enums.ChannelMchStatusEnum.审核驳回.id,
                    this._enums.ChannelMchStatusEnum.变更失败.id,
                    this._enums.ChannelMchStatusEnum.变更审核驳回.id
                ],
                mchChannelWaitingStatusArr: [
                    this._enums.ChannelMchStatusEnum.创建.id,
                    this._enums.ChannelMchStatusEnum.待渠道进件.id,
                    this._enums.ChannelMchStatusEnum.进件成功待审核.id,
                    this._enums.ChannelMchStatusEnum.转人工审核.id,
                    this._enums.ChannelMchStatusEnum.等待预签约.id,
                    this._enums.ChannelMchStatusEnum.待渠道信息变更.id,
                    this._enums.ChannelMchStatusEnum.变更成功待审核.id
                ],
                radio1Text:'选择产品',
                mchStatuses:[{"id":-1,"name":'确定'}],
                radio1: null,
                radioData: [],
                rowData: null,
                prdChoseDlgVisible: false,
                prdChoseCode: null,
                keyCompMchDlg: null,
                drawer: false,
                disableBtn: true,
                dlgModel: '',
                dlgClosed: false,
                showFV: false,
                loading: false,
                showActiveOnly: 1,
                switchLen: 65,
                switchActive: 0,
                switchInactive: 1,
                mchStatus: "正常商户",
                mchStatuses:[{"id":1,"name":'恢复正常'}, {"id":-1,"name":'关停商户'}],
                total: 0,
                page: 1,
                size: 10,
                mchs: [],

                mchInfo: {
                    id: null,
                    type: null,
                    status: null,
                    mchNo: null,
                    mchName: null,
                    shortName: null,
                    salesmanId: null,
                    salesmanName: null,
                    outMchNo: null,
                    createWay: null,
                    remark: null,
                    mchExtraInfo: {},
                    mchSettleInfo: {},
                    userProductList: [], // 产品信息列表
                    mchExtraChannelInfoWithBLOBsList: [],  // 渠道扩展信息列表
                },
                keywordList: [
                    {id:"mchName",name:"商户名称"},
                    {id:"agentName",name:"服务商名称"},
                    {id:"salesmanName",name:"客户经理名称"}
                ],
                multipleSelection: [],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    transDateScope: null,
                    agentStatId: null,
                    agentLevelId: null,
                    agentPid: null
                }
            }
        },
        mounted() {
            this.initMchs();
        },
        watch: {
            dlgClosed: {
                handler: function (val) {
                    if (this.dlgClosed === true) {
                        this.initMchs();
                    }
                }
            },
        },
        methods: {
            // 改变Table某一列的背景颜色
            // columnIndex为列下标
            columnbackgroundStyle({ row, column, rowIndex, columnIndex }) {
                if (column.label == '操作') {
                    //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                    return 'background:#fafafa;'
                }
            },
            radio1Changed() {
                let index = -1;
                this.rowData.mchExtraChannelInfoWithBLOBsList.forEach((item,idx) => {
                    if(this._enums.ProductChannelConvertEnum[this.radio1].id===item.payChannelCode) {
                        index = idx;
                    }
                });

                this.mchInfo = deepClone(this.rowData);

                this.mchInfo.mchExtraInfo = deepClone(this.rowData.mchExtraChannelInfoWithBLOBsList[index].objMchExtraInfo);
                this.mchInfo.mchSettleInfo = deepClone(this.rowData.mchExtraChannelInfoWithBLOBsList[index].objMchSettleInfo);

                this.mchInfo.mchExtraChannelInfoWithBLOBsList = [];
                this.mchInfo.mchExtraChannelInfoWithBLOBsList.push(this.rowData.mchExtraChannelInfoWithBLOBsList[index]);

                this.mchInfo.userProductList = [];
                this.rowData.userProductList.forEach(item => {
                    if(this._enums.ProductChannelCodeConvertEnum.getNameById(item.productCode)===this.rowData.mchExtraChannelInfoWithBLOBsList[index].payChannelCode)
                        this.mchInfo.userProductList.push(item);
                });

                this.prdChoseDlgVisible = false;

//                console.log("mchExtraChannelInfoWithBLOBsList",JSON.stringify(this.mchInfo.mchExtraChannelInfoWithBLOBsList));
//                console.log("userProductList",JSON.stringify(this.mchInfo.userProductList));

                if(this.dlgModel==='UPD') {
                    this.keyCompMchDlg = Date.now();
                    this.dlgClosed = false;
                }
                else if(this.dlgModel==='VIEW') {
                    this.drawer = true;
                }

            },
            initChoseChannel(data) {
                this.rowData = data;
                this.radio1 = null;
                this.radioData = [];

                if(this.dlgModel==='UPD') {
                    this.radio1Text = '修改产品';
                    data.mchExtraChannelInfoWithBLOBsList.forEach(item => {
                        if(this.mchChannelFailedStatusArr.indexOf(item.status)>-1) {
                            this.radioData.push(item);
                        }
                    });
                }
                else if(this.dlgModel==='VIEW') {
                    this.radio1Text = '查看产品';
                    data.mchExtraChannelInfoWithBLOBsList.forEach(item => {
                        this.radioData.push(item);
                    });
                }

            },
            viewAdd() {
                this.dlgModel = 'INS';
                this.keyCompMchDlg = Date.now();
                this.dlgClosed = false;

            },
            viewEdit(data) {
                this.dlgModel = 'UPD';
                this.initChoseChannel(data);
                if(this.radioData.length>0)
                    this.prdChoseDlgVisible = true;
                else
                    this.$message.warning("没有需要修改的产品!");
            },
            viewAddPrd(data) {
                this.dlgModel = 'ADD_PRD';
                this.mchInfo = deepClone(data);
                this.mchInfo.mchExtraInfo = deepClone(data.mchExtraChannelInfoWithBLOBsList[0].objMchExtraInfo);
                this.mchInfo.mchSettleInfo = deepClone(data.mchExtraChannelInfoWithBLOBsList[0].objMchSettleInfo);

                this.mchInfo.mchExtraChannelInfoWithBLOBsList = [];
                this.mchInfo.mchExtraChannelInfoWithBLOBsList.push(data.mchExtraChannelInfoWithBLOBsList[0]);


                this.keyCompMchDlg = Date.now();
                this.dlgClosed = false;
            },
            viewChange(data) {
                this.$message.error("暂不支持!");

            },
            viewSignMsg(mch, channelExtra) {
                this.$confirm('向商户【' + mch.mchName + '】,手机号【' + mch.mchExtraInfo.legalPhone + '】重发签约短信？',
                    '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postRequest("/mch/signMsgSend", {
                        id: channelExtra.mchId,
                        payChannelCode: channelExtra.payChannelCode
                    }).then(resp => {
                        if (resp) {
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            viewDetail(data) {
                this.dlgModel = 'VIEW';
                this.initChoseChannel(data);
                this.prdChoseDlgVisible = true;
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initMchs();
            },
            changeMchStatus(command) {
                let ids = [];
                this.multipleSelection.forEach(item => { ids.push(item.id); });
                this.putRequest("/mch/updateMchStat" + "?statusId=" + command + "&ids=" + ids).then(resp => {
                    if (resp) {
                        this.initMchs();
                    }
                });
            },
            changeQueryStatus() {
                this.searchDo()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
            },
            initMchs() {
                this.loading = true;
                let url = '/mch/mchInfoAll?page=' + this.page + '&size=' + this.size;
                if (this.showActiveOnly===1)
                    url = url + '&status=1';

                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.mchs = resp.data;
                        //this.total = Number(resp.total);
                        this.total = resp.total;

                    }
                })
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initMchs();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initMchs();
            },
            exportData() {

                let url = '/mch/mchInfoAll/export';

                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    url += '?'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;

                window.open(url, '_parent');
            },
        }

    }
</script>

<style scoped>
</style>
